import React from "react";
import locale from "locale";
import {
    Table,
    FormGroup,
    FormControl,
    Row,
    Col,
    ControlLabel,
    Button,
} from "react-bootstrap";

import { MAX_SHOW_ROWS } from "../../constants";

const ReminderRecipientsModalSheet = ({ sheets, onApply }) => {
    const [state, updateState] = React.useReducer(
        (prev, next) => {
            return { ...prev, ...next };
        },
        {
            sheet: [],
            sheetIndex: 0,
            selectedColumn: 0,
            selectedRow: 0,
            columnCount: 0,
        }
    );

    React.useEffect(() => {
        const current = sheets[state.sheetIndex] ?? [];
        updateState({ sheet: current });

        current.forEach((row) =>
            Object.keys(row).forEach((index) =>
                updateState({
                    columnCount: Math.max(
                        state.columnCount,
                        parseInt(index) + 1
                    ),
                })
            )
        );
    }, [state.sheetIndex]);

    function getColumns() {
        return new Array(state.columnCount)
            .fill(true)
            .map((_, index) => baseConvert(index));
    }

    function baseConvert(number, letters) {
        letters =
            letters ||
            new Array(26)
                .fill(true)
                .map((_, index) => String.fromCharCode(65 + index));

        if (number >= 0 && number < letters.length) {
            return letters[number];
        }

        return (
            baseConvert(parseInt(number / letters.length) - 1) +
            baseConvert(number % letters.length)
        );
    }

    function handleApply() {
        const emails = state.sheet
            .slice(state.selectedRow)
            .map((row) => row[state.selectedColumn])
            .filter((email) => !!email)
            .filter((value, index, self) => self.indexOf(value) === index);

        onApply(emails);
    }

    return (
        <section>
            <p>{locale("reminders.sheetInfo")}</p>
            <Row>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>{locale("reminders.sheet")}</ControlLabel>
                        <FormControl
                            componentClass="select"
                            value={state.sheetIndex}
                            onChange={({ target }) =>
                                updateState({
                                    sheetIndex: parseInt(target.value),
                                })
                            }
                        >
                            {sheets.map((_, index) => (
                                <option key={index} value={index}>
                                    {index + 1}
                                </option>
                            ))}
                        </FormControl>
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>
                            {locale("reminders.column")}
                        </ControlLabel>
                        <FormControl
                            componentClass="select"
                            value={state.selectedColumn}
                            onChange={({ target }) =>
                                updateState({
                                    selectedColumn: parseInt(target.value),
                                })
                            }
                        >
                            {getColumns().map((name, index) => (
                                <option key={index} value={index}>
                                    {name}
                                </option>
                            ))}
                        </FormControl>
                    </FormGroup>
                </Col>
                <Col xs={4}>
                    <FormGroup>
                        <ControlLabel>
                            {locale("reminders.firstRowNumber")}
                        </ControlLabel>
                        <FormControl
                            componentClass="select"
                            value={state.selectedRow}
                            onChange={({ target }) =>
                                updateState({
                                    selectedRow: parseInt(target.value),
                                })
                            }
                        >
                            {new Array(MAX_SHOW_ROWS)
                                .fill(true)
                                .map((_, index) => (
                                    <option key={index} value={index}>
                                        {index + 1}
                                    </option>
                                ))}
                        </FormControl>
                    </FormGroup>
                </Col>
            </Row>

            <div className="sheetTableContainer">
                <Table>
                    <thead>
                        <tr>
                            <th width="40" />
                            {getColumns().map((name, index) => (
                                <th key={index}>{name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {state.sheet
                            .slice(0, MAX_SHOW_ROWS)
                            .map((row, rowIndex) => (
                                <tr
                                    key={rowIndex}
                                    className={
                                        (rowIndex >= state.selectedRow
                                            ? "selectedRow"
                                            : "") +
                                        (rowIndex === state.selectedRow
                                            ? " selectedRowFirst"
                                            : "")
                                    }
                                >
                                    <td>{rowIndex + 1}</td>
                                    {getColumns().map((_, colIndex) => (
                                        <td
                                            key={colIndex}
                                            className={
                                                colIndex ===
                                                state.selectedColumn
                                                    ? "selectedColumn"
                                                    : ""
                                            }
                                        >
                                            {row[colIndex] || null}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </div>

            <Button onClick={handleApply} bsStyle="primary">
                {locale("reminders.apply")}
            </Button>
        </section>
    );
};

export default ReminderRecipientsModalSheet;
